import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { faEye } from "@fortawesome/free-solid-svg-icons/faEye";

import { Spacing } from "../../../theme/Spacing";
import { TestIDs } from "../../../tests/types/testIds";
import { GhostButton } from "./DuplicateCardPrimitives";

const IconButton = styled(GhostButton)`
  flex-shrink: 0;
  padding: ${Spacing.xs} ${Spacing.s};
  background: ${({ theme }) => theme.main};
`;

type Props = {
  entryId: string;
  onPreview: ATVoidFunction<string>;
};

export const EntryPreviewButton: React.FC<Props> = ({ entryId, onPreview }) => {
  const { t } = useTranslation();

  return (
    <IconButton
      fontSize="xs"
      icon={faEye}
      info={t("entries.duplicates.preview.tooltip")}
      dataTestId={TestIDs.entries.duplicates.resolve.preview(entryId)}
      onClick={() => onPreview(entryId)}
    />
  );
};
